
import { SET_CHILDRENS_COUNT, SET_CHILDREN_INFO } from "../actions/types";

const initialState = {
  childrensCount: 1,
  childrens: [
    {
      name: 'Child 1',
      timeParent1: 50,
      timeParent2: 50,
      timeUnitIndex: 0 
    }
],
}

const childrensReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_CHILDRENS_COUNT:
      let newChildrens = state.childrens.slice();
      if (payload>state.childrens.length){
        newChildrens.push({
          name: `Child ${payload}`,
          timeParent1: 50,
          timeParent2: 50,
          timeUnitIndex: 0 
        });
      }
      return {
        ...state,
        childrensCount: payload,
        childrens: newChildrens
      }
    case SET_CHILDREN_INFO:
      let newChildrensInfo = state.childrens.slice();
      newChildrensInfo[payload.index][payload.key] = payload.value!=='' ? payload.value : `Child ${payload.index}`;;
      return {
        ...state,
        childrens: newChildrensInfo,
      }
    default:
      return state;
  }
}

export default childrensReducer;